export interface Article {
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  date: string;
  image: string;
  tags: string[];
  relatedArticles: string[];
}

export const articles: Article[] = [
  {
    slug: 'ruhe-tiaoxuan-hetianyu',
    title: '如何挑选一块好玉？行家不外传的和田玉选购指南',
    summary: '和田玉市场鱼龙混杂，从玉质、白度、油性、结构四个维度，教你快速辨别优劣，选到心仪的掌中珍宝。',
    content: `<p>和田玉，被誉为"国玉"，是中国传统文化中最为珍贵的宝石之一。然而，随着市场需求的不断增长，市面上鱼龙混杂，如何挑选一块真正的好玉，成为许多收藏爱好者最关心的问题。</p>
<h2>一、看玉质——温润如玉不只是形容词</h2>
<p>好的和田玉，首先要有"温润"的质感。所谓温润，是指玉石表面有一种柔和的光泽，不刺眼、不张扬，却让人百看不厌。这种光泽来自玉石内部结构的细腻均匀，光线在玉石内部经过多次折射后，形成一种内敛而深邃的视觉感受。</p>
<p>选购时，可以将玉石放在自然光下观察，好的和田玉会呈现出一种"油脂光泽"，如同凝固的油脂一般温润。如果光泽过于刺眼或过于暗淡，都需要提高警惕。</p>
<h2>二、看白度——羊脂白是最高标准</h2>
<p>和田玉以白为贵，但"白"也分很多等级。最顶级的白度被称为"羊脂白"，如同凝结的羊脂一般，白中透着一丝微黄或微粉的暖调，非常耐看。</p>
<p>普通消费者在选购时，不必过分追求羊脂白的极致，选择白度均匀、色泽自然的作品即可。需要注意的是，有些商家会通过漂白等手段人为提白，这种玉石佩戴时间长了容易出现裂纹和变色。</p>
<h2>三、看油性——上手的感觉不会骗人</h2>
<p>油性是和田玉最独特的品质之一。好的和田玉上手后会给人一种"油腻"的触感，仿佛表面有一层薄薄的油脂。这种油性来自玉石天然的矿物结构，无法人工仿造。</p>
<p>选购时可以将玉石握在手中几分钟，感受温度变化和手感。真正的和田玉导热快，握在手中很快就能感受到温度的变化，而且会有一种越摸越润的感觉。</p>
<h2>四、看结构——放大镜下的真相</h2>
<p>和田玉的内部结构是判断真伪和品质的重要依据。优质和田玉在强光手电下观察，内部结构应该紧密均匀，呈现出"毡状结构"或"纤维交织结构"，不应有明显的裂纹、杂质或气泡。</p>
<p>对于普通消费者来说，如果条件允许，建议带上一个10倍放大镜，仔细观察玉石的表面和内部。天然和田玉的表面通常有细微的"汗毛孔"和"指甲纹"，这些都是天然形成的特征，人工合成品很难模仿。</p>
<h2>五、选购建议</h2>
<p>对于初入门的收藏爱好者，建议从以下几个方面入手：</p>
<ul>
<li><strong>多看少买：</strong>先花时间学习和观察，积累足够的经验后再出手。</li>
<li><strong>从小件开始：</strong>先从小件的挂件、手把件入手，价格相对亲民，也容易辨别品质。</li>
<li><strong>选择信誉商家：</strong>尽量选择有固定经营场所、口碑良好的商家购买。</li>
<li><strong>索要证书：</strong>高价位的玉石应配有权威机构出具的鉴定证书。</li>
</ul>
<p>收藏和田玉，不仅是一种投资，更是一种文化的传承。希望每位爱好者都能找到属于自己的那一方美玉。</p>`,
    category: 'shoucang-jingpin',
    author: '陈玉明',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20white%20Hetian%20jade%20pieces%20displayed%20on%20dark%20wooden%20surface%20with%20magnifying%20glass%2C%20warm%20natural%20lighting%2C%20elegant%20jade%20appreciation%20scene%2C%20cream%20background%2C%20professional%20photography&width=1200&height=600&seq=article-01&orientation=landscape',
    tags: ['和田玉', '选购指南', '收藏', '鉴定'],
    relatedArticles: ['wenwan-panwan-rumen', 'zimu-zisha-bijiao', 'niyao-zhidao-de-mingci'],
  },
  {
    slug: 'wenwan-panwan-rumen',
    title: '文玩盘玩入门：从新手到达人的必修课',
    summary: '盘玩是文玩的核心乐趣，但不同材质有不同的盘玩方法。本文为你梳理最全面的文玩盘玩指南，助你快速从小白变达人。',
    content: `<p>文玩的最大魅力，在于"盘"。通过日复一日的把玩，文玩会逐渐产生包浆，色泽愈发温润，手感愈发舒适。这个过程，既是人与物之间的交流，也是心性的修炼。</p>
<h2>一、什么是盘玩？</h2>
<p>盘玩，简单来说就是用手反复把玩文玩物件，通过手掌的温度、汗液和油脂，让文玩表面逐渐形成一层自然的光泽——这就是我们常说的"包浆"。包浆是时间的印记，也是文玩价值的体现。</p>
<h2>二、不同材质的盘玩方法</h2>
<h3>1. 木质类（紫檀、黄花梨、崖柏）</h3>
<p>木质文玩是最常见的品类，盘玩时需要注意：</p>
<ul>
<li><strong>净手盘玩：</strong>盘玩前一定要洗手，避免污渍渗入木质纹理。</li>
<li><strong>先布后手：</strong>新入手的木质文玩，建议先用棉布盘玩1-2周，让表面先形成一层基础光泽。</li>
<li><strong>少量多次：</strong>每次盘玩15-20分钟即可，不要长时间持续。</li>
<li><strong>忌水忌汗：</strong>木质怕水，大汗手盘玩容易导致木质发黑。</li>
</ul>
<h3>2. 菩提类（金刚、星月、凤眼）</h3>
<p>菩提子是最适合新手入门的文玩品类：</p>
<ul>
<li><strong>前期勤刷：</strong>新菩提子表面有果肉残留，需要用刷子反复刷洗。</li>
<li><strong>三分盘七分刷：</strong>这是菩提盘玩的黄金法则。</li>
<li><strong>变色是正常的：</strong>菩提子在盘玩过程中会经历多次变色，这是自然过程。</li>
</ul>
<h3>3. 玉石类（和田玉、翡翠）</h3>
<p>玉石类文玩不需要刻意"盘"，日常佩戴就是最好的养护。人体的温度和油脂会让玉石越来越润，这就是"人养玉"的道理。</p>
<h3>4. 核桃类</h3>
<p>文玩核桃是最经典的把件品类，盘玩要诀：</p>
<ul>
<li>新核桃要先"打底"——用硬毛刷反复刷洗，去除表面白霜。</li>
<li>盘玩时要轻柔，避免碰撞导致破损。</li>
<li>核桃喜汗，但大汗后要及时用布擦干。</li>
</ul>
<h2>三、盘玩的禁忌</h2>
<ul>
<li><strong>忌化学试剂：</strong>不要使用任何化学清洁剂或上光剂。</li>
<li><strong>忌暴晒：</strong>阳光直射会导致木质开裂、玉石失色。</li>
<li><strong>忌温差过大：</strong>骤冷骤热对任何文玩都是致命伤害。</li>
<li><strong>忌急功近利：</strong>盘玩是慢功夫，包浆需要时间沉淀。</li>
</ul>
<p>盘玩之美，在于等待。每一道包浆都是时光的见证，每一次把玩都是与器物之间的对话。愿你在盘玩中找到属于自己的那份宁静与满足。</p>`,
    category: 'wenwan-bajian',
    author: '林品玩',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Various%20Chinese%20cultural%20playthings%20including%20walnuts%20and%20bodhi%20beads%20in%20hands%2C%20warm%20natural%20lighting%2C%20close-up%20hand%20holding%20collectibles%2C%20cream%20background%2C%20lifestyle%20photography&width=1200&height=600&seq=article-02&orientation=landscape',
    tags: ['文玩', '盘玩', '入门', '技巧'],
    relatedArticles: ['ruhe-tiaoxuan-hetianyu', 'niyao-zhidao-de-mingci'],
  },
  {
    slug: 'zimu-zisha-bijiao',
    title: '紫砂壶选购攻略：紫泥、朱泥、段泥怎么选？',
    summary: '紫砂壶的泥料种类繁多，紫泥、朱泥、段泥各有千秋。不同泥料适合泡什么茶？新手该怎么选？一文讲透。',
    content: `<p>紫砂壶是中国茶文化中不可或缺的一部分，而泥料则是紫砂壶的灵魂。面对琳琅满目的紫砂壶，很多人都会困惑：紫泥、朱泥、段泥有什么区别？该选哪一种？</p>
<h2>一、紫泥——最经典的选择</h2>
<p>紫泥是紫砂壶中最常见的泥料，产于宜兴黄龙山。它的颜色从紫褐色到紫红色不等，质地细腻，可塑性好。</p>
<p><strong>特点：</strong>透气性适中，保温性好，适合冲泡乌龙茶、普洱茶等发酵程度较高的茶叶。紫泥壶"养"得快，使用一段时间后壶身会逐渐变得温润有光泽。</p>
<p><strong>推荐人群：</strong>新手入门首选，性价比高，选择范围广。</p>
<h2>二、朱泥——红润似朱砂</h2>
<p>朱泥以颜色红润著称，矿料中氧化铁含量较高，烧成后呈现朱红色或橙红色，非常讨喜。</p>
<p><strong>特点：</strong>质地致密，透气性较紫泥差，但保温性更好。朱泥壶特别适合冲泡高香型的茶叶，如铁观音、台湾高山茶等，能够很好地锁住茶香。</p>
<p><strong>注意事项：</strong>朱泥收缩率大，制作难度高，成品率低，因此价格通常较高。选购时注意辨别是否添加了化工颜料。</p>
<h2>三、段泥——清新淡雅</h2>
<p>段泥（也称团泥）是紫砂泥料中颜色最浅的一种，呈黄色或米黄色，给人以清新雅致的感觉。</p>
<p><strong>特点：</strong>透气性最好，特别适合冲泡绿茶、白茶等轻发酵或不发酵的茶叶。用段泥壶泡龙井、碧螺春，能够充分发挥绿茶的清新鲜爽。</p>
<p><strong>推荐人群：</strong>喜欢喝绿茶的茶友，或者想要一把与众不同的壶。</p>
<h2>四、选购建议</h2>
<ul>
<li><strong>新手首选紫泥：</strong>价格适中，适应性强，不容易"踩坑"。</li>
<li><strong>根据茶叶选泥料：</strong>乌龙普洱选紫泥，高香茶选朱泥，绿茶白茶选段泥。</li>
<li><strong>不要迷信"名家壶"：</strong>对于新手来说，一把做工精良的实用壶远比所谓的"名家壶"更有意义。</li>
<li><strong>多看多摸：</strong>好的紫砂壶手感细腻，表面有自然的颗粒感，壶盖与壶身配合紧密。</li>
</ul>
<p>一把好壶，不仅能泡出好茶，更能在使用过程中不断"成长"。愿每位爱茶之人都能找到心仪的紫砂壶。</p>`,
    category: 'chaye-chaju',
    author: '苏茶人',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Three%20different%20types%20of%20Yixing%20purple%20clay%20teapots%20in%20various%20colors%20displayed%20together%2C%20warm%20natural%20lighting%2C%20elegant%20tea%20culture%20scene%2C%20cream%20background%2C%20professional%20photography&width=1200&height=600&seq=article-03&orientation=landscape',
    tags: ['紫砂', '选购', '泥料', '茶具'],
    relatedArticles: ['ruhe-tiaoxuan-hetianyu', 'wenwan-panwan-rumen', 'niyao-zhidao-de-mingci'],
  },
  {
    slug: 'niyao-zhidao-de-mingci',
    title: '文玩圈的"黑话"——你必须知道的二十个行业术语',
    summary: '包浆、挂瓷、开片、玉化……文玩圈有自己的一套术语体系。了解这些名词，才能真正进入文玩的世界。',
    content: `<p>每个圈子都有自己的"语言"，文玩圈也不例外。对于刚入门的爱好者来说，了解这些行业术语，不仅能让你在交流中更加自信，也能帮助你更好地理解和欣赏文玩之美。</p>
<h2>一、关于品质状态</h2>
<h3>包浆</h3>
<p>文玩圈最常听到的词。指文玩在长期盘玩后，表面形成的一层自然光泽。包浆是时间的沉淀，是文玩价值的重要体现。好的包浆温润内敛，不刺眼。</p>
<h3>挂瓷</h3>
<p>特指菩提类文玩在盘玩初期，表面形成的一层类似瓷器光泽的效果。挂瓷是包浆的前奏，出现挂瓷说明盘玩方向正确。</p>
<h3>开片</h3>
<p>指瓷器、紫砂等器物表面的釉层或胎体因年代久远而产生的自然裂纹。开片是岁月留下的印记，备受藏家珍视。</p>
<h3>玉化</h3>
<p>原本多用于描述松石、蜜蜡等材质在盘玩后呈现出玉石般温润质感的过程。现在也泛指任何文玩经过长期把玩后出现的温润光泽。</p>
<h2>二、关于盘玩技法</h2>
<h3>武盘</h3>
<p>指力度较大、速度较快的盘玩方式，多见于核桃、金刚等硬度较高的文玩。武盘能快速产生变化，但风险也较大。</p>
<h3>文盘</h3>
<p>与武盘相对，指轻柔缓慢地盘玩，多见于木质、玉器等较为娇贵的文玩。文盘虽然见效慢，但更安全持久。</p>
<h3>刷</h3>
<p>用刷子清理文玩表面，尤其在菩提类文玩中非常重要。"三分盘七分刷"是菩提盘玩的黄金法则。</p>
<h2>三、关于品相描述</h2>
<h3>全品</h3>
<p>指没有任何瑕疵的完美品相。</p>
<h3>有修</h3>
<p>指器物曾经有过破损但经过修复。一般来说，有修的物品价值会大打折扣。</p>
<h3>原矿</h3>
<p>多用于紫砂、绿松石等领域，指未经过任何人工优化处理的天然矿料。</p>
<p>了解这些术语，你就已经在文玩之路上迈出了重要的一步。不过要记住：术语只是工具，真正重要的是你对器物本身的感受和热爱。</p>`,
    category: 'wenwan-bajian',
    author: '林品玩',
    date: '2026-06-25',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20various%20Chinese%20cultural%20collectibles%20with%20beautiful%20patina%20on%20wooden%20surface%2C%20warm%20natural%20lighting%2C%20close-up%20detail%20shot%2C%20cream%20background%2C%20professional%20lifestyle%20photography&width=1200&height=600&seq=article-04&orientation=landscape',
    tags: ['文玩', '术语', '入门', '知识'],
    relatedArticles: ['wenwan-panwan-rumen', 'ruhe-tiaoxuan-hetianyu'],
  },
  {
    slug: 'chaqi-yanghu-zhinan',
    title: '茶器养护全攻略：让你的紫砂壶越用越美',
    summary: '一把好紫砂壶，三分用七分养。从开壶到日常养护，从泡养到存放，手把手教你如何养出一把温润如玉的好壶。',
    content: `<p>紫砂壶的魅力不仅在于其本身，更在于使用过程中不断"成长"的过程。一把养护得当的紫砂壶，用上几年后会变得温润如玉，茶香四溢。而养护不当，则可能黯然失色，甚至开裂损坏。</p>
<h2>一、新壶开壶——唤醒沉睡的紫砂</h2>
<p>新买的紫砂壶需要"开壶"，去除烧制过程中残留的窑灰和土味。常见的方法有：</p>
<ul>
<li><strong>清水煮壶法：</strong>将壶放入冷水中，小火慢煮至水开，持续10-15分钟，自然冷却后取出。</li>
<li><strong>豆腐煮壶法：</strong>在清水中加入一块老豆腐，与壶同煮。豆腐中的蛋白质能吸附壶内的杂质。</li>
<li><strong>茶叶煮壶法：</strong>用准备冲泡的茶叶煮壶，让壶"认茶"，日后泡茶更纯正。</li>
</ul>
<p>无论哪种方法，开壶后都要用清水反复冲洗，然后用干净的茶巾擦干，放在通风处自然晾干。</p>
<h2>二、日常使用——泡养结合</h2>
<ul>
<li><strong>一壶一茶：</strong>紫砂壶有吸附性，建议一把壶只泡一种茶，避免串味。</li>
<li><strong>及时清理：</strong>每次使用后及时倒出茶渣，用清水冲洗干净。</li>
<li><strong>不要用洗洁精：</strong>化学清洁剂会破坏壶身已经形成的茶油包浆。</li>
<li><strong>用茶汤养壶：</strong>泡茶时可以用茶汤浇淋壶身，这是最自然的养壶方式。</li>
</ul>
<h2>三、养壶技巧</h2>
<ul>
<li><strong>茶巾擦拭：</strong>趁壶身温热时，用干净的茶巾反复擦拭壶身，能促进包浆形成。</li>
<li><strong>避免油污：</strong>手上有油污时不要接触壶身，油污会堵塞紫砂的气孔。</li>
<li><strong>适度使用：</strong>紫砂壶也需要"休息"，建议多把壶轮换使用。</li>
</ul>
<h2>四、存放要点</h2>
<ul>
<li><strong>完全干燥：</strong>存放前确保壶内外完全干燥。</li>
<li><strong>通风避光：</strong>存放在通风、避光的地方，避免潮湿和暴晒。</li>
<li><strong>壶盖分开放：</strong>长期不用时，壶盖和壶身分开存放，避免密封导致发霉。</li>
</ul>
<p>养壶如养心。在日复一日的泡茶养壶中，你不仅收获了一把好壶，更收获了一份从容与宁静。</p>`,
    category: 'chaye-chaju',
    author: '苏茶人',
    date: '2026-06-10',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Yixing%20purple%20clay%20teapot%20with%20tea%20being%20poured%2C%20warm%20steam%20rising%2C%20elegant%20tea%20ceremony%20scene%2C%20cream%20background%2C%20natural%20lighting%2C%20lifestyle%20photography&width=1200&height=600&seq=article-05&orientation=landscape',
    tags: ['紫砂', '养护', '茶器', '技巧'],
    relatedArticles: ['zimu-zisha-bijiao', 'wenwan-panwan-rumen'],
  },
  {
    slug: 'songli-xuanze-zhinan',
    title: '送礼的艺术：如何选一份有温度的掌中厚礼',
    summary: '送礼是一门学问，选对礼物更是对收礼人最大的尊重。从场合到对象，从预算到寓意，为你梳理最全面的掌中之物送礼指南。',
    content: `<p>在中国传统文化中，送礼是一门深奥的学问。一份好的礼物，不仅要得体大方，更要传递出送礼人的真诚与用心。掌中之物的每一件精品，都适合作为送礼佳选。</p>
<h2>一、按场合选择</h2>
<h3>商务送礼</h3>
<p>商务场合的礼物，讲究大方得体、寓意吉祥。推荐：</p>
<ul>
<li><strong>紫砂壶：</strong>品味与文化的象征，适合送给合作伙伴或重要客户。</li>
<li><strong>工艺摆件：</strong>如木雕、陶瓷等，既能装点办公室，又不失雅致。</li>
</ul>
<h3>长辈送礼</h3>
<p>送给长辈的礼物，重在心意和健康寓意：</p>
<ul>
<li><strong>和田玉挂件：</strong>玉养人，寓意健康平安。</li>
<li><strong>文玩把件：</strong>核桃、蜜蜡等，既有趣味又有益健康。</li>
</ul>
<h3>亲友送礼</h3>
<p>朋友之间的礼物，可以更加个性化：</p>
<ul>
<li><strong>茶具套装：</strong>爱茶之人的心头好。</li>
<li><strong>百宝嵌首饰盒：</strong>兼具实用与观赏价值。</li>
</ul>
<h2>二、按预算选择</h2>
<ul>
<li><strong>1000元以内：</strong>青瓷茶盏、崖柏把件、小型木雕摆件</li>
<li><strong>1000-5000元：</strong>紫砂壶、蜜蜡把件、中档木雕、首饰盒</li>
<li><strong>5000-10000元：</strong>精品紫砂壶、端砚、高档木雕摆件</li>
<li><strong>10000元以上：</strong>和田玉挂件、翡翠饰品、收藏级精品</li>
</ul>
<h2>三、送礼小贴士</h2>
<ul>
<li><strong>了解收礼人：</strong>投其所好，才能让礼物更有价值。</li>
<li><strong>注重包装：</strong>精美的包装能提升礼物的档次和仪式感。</li>
<li><strong>附上心意卡：</strong>亲手写几句祝福语，让礼物更有温度。</li>
<li><strong>考虑实用性：</strong>能被日常使用的礼物，更能让收礼人时常想起你。</li>
</ul>
<p>一份好的礼物，是心意的载体。愿你的每一份礼物，都能温暖收礼人的心。</p>`,
    category: 'liwu-jingxuan',
    author: '陈玉明',
    date: '2026-05-28',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20gift%20presentation%20with%20traditional%20craft%20items%20wrapped%20in%20silk%2C%20warm%20golden%20lighting%2C%20luxurious%20gift%20giving%20scene%2C%20cream%20background%2C%20lifestyle%20photography&width=1200&height=600&seq=article-06&orientation=landscape',
    tags: ['送礼', '礼品', '选购', '指南'],
    relatedArticles: ['ruhe-tiaoxuan-hetianyu', 'zimu-zisha-bijiao'],
  },
];

export const getArticleBySlug = (slug: string): Article | null => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getRelatedArticles = (slugs: string[]): Article[] => {
  return articles.filter((a) => slugs.includes(a.slug));
};